module.exports = __webpack_public_path__ + "img/weapp-header-dark.86cbbc15.png";